import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'

import { showGlobalModal, hideGlobalModal } from '../plugins/globalModal';

const app = createApp(App);

// 注册到全局属性
app.config.globalProperties.$globalModal = {
  show: showGlobalModal,
  hide: hideGlobalModal
};

// 同时作为独立的函数导出，方便在组合式API中使用
export { showGlobalModal, hideGlobalModal };
app.use(router)
app.use(ElementPlus)
app.mount('#app')